import cn from 'classnames'
import s from './Input.module.css'
interface Props {
  defaultValue?: string
  placeHolder?: string
  label?: string
  name: string
  error?: any
  className?: string
  validation?: any
  register: any
  errorMessage?: string
  type?: string
  disabled?: boolean
  validated?: boolean
  rows?: number
}
const Input = ({
  className,
  defaultValue,
  placeHolder,
  label,
  name,
  register,
  error,
  errorMessage,
  validation,
  type,
  disabled,
  validated,
  rows,
}: Props) => {
  const rootClassName = cn(s.root, error ? `${s.inputError}` : '', className)
  return (
    <div className="relative flex flex-col ">
      {label && (
        <label className={cn('label-bold pb-2', { 'text-inputError': error })}>
          {label}
        </label>
      )}
      {type === 'textarea' ? (
        <textarea
          className={rootClassName}
          placeholder={placeHolder}
          defaultValue={defaultValue}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          disabled={disabled}
          rows={rows}
          {...register(name, validation ? validation : {})}
        ></textarea>
      ) : (
        <input
          className={rootClassName}
          placeholder={placeHolder}
          defaultValue={defaultValue}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          type={type || 'text'}
          disabled={disabled}
          {...register(name, validation ? validation : {})}
        />
      )}
      {error && errorMessage && (
        <div className="label mt-1 text-errorRed">{errorMessage}</div>
      )}
    </div>
  )
}

export default Input
